module.exports = __webpack_public_path__ + "img/2-light.5af196fc.png";